import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const administrationRoutes: MenuInterface[] = [
    {
        code: 'GestionParametrageApplication_ViewModel',
        route: [
            {
                content: 'administration/application-settings',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionCommission_ViewModel',
        route: [
            {
                content: 'administration/commissions/list',
                focus: 'empty'
            },
            {
                queryParams: {closeButton: 1}
            }
        ]
    },
    {
        code: 'GestionCEDelegation_ViewModel',
        route: [
            {
                content: 'administration/delegation/list',
                focus: 'empty'
            },
            {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ],
        additionalConditionFn: (menu) => menu.MenuPage.ListeParametres?.MenuPageParamDTO?.[0]?.Valeur === 'MULTI'
    },
    {
        code: 'GestionCEDelegation_ViewModel',
        route: [
            {
                content: 'administration/informations-cse',
                focus: 'empty'
            }, 'content'
        ],
        additionalConditionFn: (menu) => menu.MenuPage.ListeParametres?.MenuPageParamDTO?.[0]?.Valeur === 'MONO'
    },
    {
        code: 'GestionStock_ViewModel',
        route: [
            {
                content: 'administration/stocks/list',
                focus: 'empty'
            }, {queryParams: {closeButton: 1}}
        ]
    },
    {
        code: 'GestionUsers_ViewModel',
        route: [{content: 'administration/users/list', focus: 'empty'}, {primaryRoute: 'content', queryParams: {closeButton: 1}}]
    },
    {
        code: 'GestionParametrageProfilDroit_ViewModel',
        route: [
            {content: 'administration/rights-profile/list', focus: 'empty'},
            {primaryRoute: 'content', queryParams: {closeButton: 1}}
        ]
    }
];
